import LoggerService from '@/services/isomorphic/LoggerService';
import { exhaustiveFallback } from '@/utils/function-utils';
import type { AspectRatio } from '../template-data/AspectRatio';

/**
 * Gets the Image aspect ratio from the aspect ratio enum.
 * @param aspectRatio - A string value that is configured for the registry.
 * @returns The aspect ratio as a number.
 */
export const getAspectRatioNumberFromEnum = (
  aspectRatio: AspectRatio
): number => {
  switch (aspectRatio) {
    case '9:16':
      return 9 / 16;
    case '3:4':
      return 3 / 4;
    case '3:5':
      return 3 / 5;
    case '2:3':
      return 2 / 3;
    case '1:2':
      return 1 / 2;
    case '1:1':
      return 1;
    case '2:1':
      return 2 / 1;
    case '4:1':
      return 4 / 1;
    case '4:3':
      return 4 / 3;
    case '5:3':
      return 5 / 3;
    case '8:3':
      return 8 / 3;
    case '16:9':
      return 16 / 9;
    default:
      return exhaustiveFallback(aspectRatio, () => {
        LoggerService.error(
          `Unknown aspect ratio: ${aspectRatio}. Defaulting to 1:1.`
        );
        return 1;
      });
  }
};
